import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { useHistory } from "react-router-dom";
import { withMainLayout } from "../../view/LayoutHOCs";
import SystemSettingsSection from "./SystemSettingsSection";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";

const breadcrumbs = [
  {
    text: "Home",
    redirectTo: "/",
    iconClassName: "icon-home"
  },
  {
    text: "System Settings",
    redirectTo: "/system-settings",
  }
]

function SystemSettingsPage({ userCapability }) {

  const history = useHistory();

  useEffect(() => {
    layoutService.setPageTitle('System Settings')
    layoutService.setBreadcrumbs(breadcrumbs)
  }, [history.location])

  //#region Set User Capabilities
  const checkCapability = async () => {
    try {
      if (userCapability) {
        const capability = userCapability.find(item => item.component === "systemsettings" && item.type === "page")?.permission;
        if (capability === -1) {
          sessionStorage.removeItem('access_token');
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    checkCapability();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);
  //#endregion


  return (
    <>
      <InfoBoxes />
      <SystemSettingsSection />
    </>
  )

}

function mapStateToProps(state) {
  const auth = state.auth;
  return {
    userCapability: auth.userCapability,
  }
}

export default withMainLayout(connect(mapStateToProps)(SystemSettingsPage));